import Vue from "vue";
import App from "./App.vue";
// import AOS from "aos";
import "aos/dist/aos.css";
// import vueJquery from "vue-jquery";

// Import F7
import Framework7 from "framework7/framework7.esm.bundle.js";

// Import F7 Vue Plugin
import Framework7Vue from "framework7-vue/framework7-vue.esm.bundle.js";

// Import F7 Styles
import "framework7/css/framework7.bundle.css";

// Import F7 Icons
import "framework7-icons/css/framework7-icons.css";

Vue.config.productionTip = false;

Framework7.use(Framework7Vue);

// Vue.use(vueJquery);

new Vue({
  el: "#app",
  template: "<App />",
  components: {
    app: App
  },
  mounted() {
    import("aos").then(AOS => AOS.init());
  },
  render: h => h(App)
}).$mount("#app");
